import {
  getLocales,
  createLocale,
  updateLocale,
  deleteLocale,
  getLocaleById,
} from "@/modules/locales/api";
import StorageLogger from "@/modules/common/utils/storageLogger";

export default {
  namespaced: true,
  state: {
    DATA_LOCALES: [],
    TOTAL_LOCALES: 0,
    DETAIL_LOCALE: null,
    CURRENT_LOCALE: "ru",
  },

  getters: {
    GET_LOCALES: (state: any) => {
      return state.DATA_LOCALES;
    },
    GET_TOTAL_LOCALES: (state: any) => {
      return state.TOTAL_LOCALES;
    },
    GET_DETAIL_LOCALE: (state: any) => {
      return state.DETAIL_LOCALE;
    },
    GET_CURRENT_LOCALE: (state: any) => {
      const localeValue = StorageLogger.getItem("locale") || null;
      if (!localeValue || localeValue === null || localeValue === "null") {
        StorageLogger.setItem("locale", state.CURRENT_LOCALE);
        return state.CURRENT_LOCALE;
      }
      state.CURRENT_LOCALE = localeValue;
      return state.CURRENT_LOCALE;
    },
  },

  mutations: {
    SET_LOCALES(state: any, data: any) {
      state.DATA_LOCALES = data;
    },
    SET_TOTAL_LOCALES(state: any, data: any) {
      state.TOTAL_LOCALES = data;
    },
    UPDATED_OBJ_FROM_LOCALES(state: any, data: any) {
      state.DATA_LOCALES = state.DATA_LOCALES.map((item: any) => {
        return item.id === data.id ? { ...item, ...data } : item;
      });
    },
    DELETE_OBJ_FROM_LOCALES(state: any, id: number) {
      state.DATA_LOCALES = state.DATA_LOCALES.filter((item: any) => {
        return item.id !== id;
      });
      state.TOTAL_LOCALES = state.TOTAL_LOCALES - 1;
    },
    SET_DETAIL_LOCALE(state: any, data: any) {
      state.DETAIL_LOCALE = data;
    },
    SET_CURRENT_LOCALE(state: any, locale: string) {
      state.CURRENT_LOCALE = locale;
      StorageLogger.setItem("locale", locale);
    },
  },

  actions: {
    async FETCH_LOCALES(context: any, payload: any) {
      try {
        const res = await getLocales(payload);
        context.commit("SET_TOTAL_LOCALES", res.data.total);
        context.commit("SET_LOCALES", res.data.items);
      } catch (error: any) {
        console.log(`Error FETCH_LOCALES => ${error}`);
        console.log(error.response);
      }
    },

    async CREATE_LOCALE(context: any, payload: any) {
      try {
        const res = await createLocale(payload);
        if (res.status === 201) {
          await context.dispatch("FETCH_LOCALES");
        }
      } catch (error: any) {
        console.log(`Error CREATE_LOCALE => ${error}`);
        console.log(error.response);
      }
    },

    async UPDATE_LOCALE(context: any, payload: any) {
      try {
        const { id, ...data } = payload;
        const res = await updateLocale(id, data);
        if (res.status === 200) {
          context.commit("UPDATED_OBJ_FROM_LOCALES", res.data);
        }
      } catch (error: any) {
        console.log(`Error UPDATE_LOCALE => ${error}`);
        console.log(error.response);
      }
    },

    async DELETE_LOCALE(context: any, id: number) {
      try {
        const res = await deleteLocale(id);
        if (res.status === 204) {
          context.commit("DELETE_OBJ_FROM_LOCALES", id);
        }
      } catch (error: any) {
        console.log(`Error DELETE_LOCALE => ${error}`);
        console.log(error.response);
      }
    },

    async FETCH_DETAIL_LOCALE(context: any, locale_id: number) {
      try {
        const res = await getLocaleById(locale_id);
        context.commit("SET_DETAIL_LOCALE", res.data);
      } catch (error: any) {
        console.log(`Error FETCH_DETAIL_LOCALE => ${error}`);
        console.log(error.response);
      }
    },
  },
};
